import axios from 'axios';
import { getToken } from '@/utilities/cookies';
const EpiApiClient = axios.create({
    baseURL: window.appConfig?.epiBaseUrl || '',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});
EpiApiClient.interceptors.request.use((c)=>{
    const token = getToken();
    if (token) {
        c.headers['Authorization'] = `Bearer ${token}`;
    }    
    return c;
});

export const isCancel = axios.isCancel;
export default EpiApiClient;